import { IRecipientCandidate } from 'interfaces/IFleetMonitoring'

export const AVATAR_COLORS = [
  '#2563eb', '#7c3aed', '#059669', '#d97706', '#dc2626', '#0891b2', '#db2777', '#4f46e5',
]

export const recipientLabel = (c: IRecipientCandidate): string => c.name?.trim() || c.email

export const recipientInitials = (c: IRecipientCandidate): string => {
  const base = recipientLabel(c)
  const parts = base.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return base.slice(0, 2).toUpperCase()
}

export const recipientColor = (key: string): string => {
  let hash = 0
  for (let i = 0; i < key.length; i += 1) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}
